import { useMutation } from "@tanstack/react-query";
import { deleteFloorPlanMemoText } from "~/_legacy/apis/delete-floor-plan-memo-text";
import { isNullish } from "~/_legacy/utils/compare";

export const DELETE_FLOOR_PLAN_MEMO_TEXT_MUTATION_KEY = "deleteFloorPlanMemoText";

export function useDeleteFloorPlanMemoText({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  const { mutateAsync } = useMutation({
    mutationKey: [DELETE_FLOOR_PLAN_MEMO_TEXT_MUTATION_KEY, branchUid, branchVersionId],
    mutationFn: ({ floorPlanId, memoTextId }: { floorPlanId: number; memoTextId: number }) => {
      if (isNullish(branchUid)) {
        throw new Error("Branch uid가 필요합니다.");
      }
      return deleteFloorPlanMemoText({
        branchUid,
        branchVersionId,
        floorPlanId,
        memoTextId,
      });
    },
  });

  return {
    deleteFloorPlanMemoText: mutateAsync,
  };
}
